import { render, staticRenderFns } from "./MFAViewActivated.vue?vue&type=template&id=089c6191"
import script from "./MFAViewActivated.vue?vue&type=script&lang=ts"
export * from "./MFAViewActivated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports